<template>
  <div class="assessment">
    <div class="assessment_header">
      <div class="assessment_header_left" @click="returnBtn">
        <i class="iconfont iconfanhui"></i>
        <p>返回</p>
      </div>

      <div class="assessment_header_right" @click="skipStep()" v-show="step !== 'stepFinish' && step !== 'stepSkip' && step !== 'stepHelp'">
        <p>跳过</p>
        <i class="iconfont iconnext"></i>
      </div>
    </div>

    <div class="step step1" v-show="step1">
      <div class="step_bg">
        <div class="titleBox">
          <div>
            <p>1/4：</p>
          </div>
          <div>
            <p>我们需要知道{{ child === 1 ? '孩子' : '您' }}的部分信息</p>
            <p>以便更好的为{{ child === 1 ? '孩子' : '您' }}提供服务</p>
          </div>
        </div>
        <van-cell-group>
          <div class="cell">
            <div class="cell_label">性别</div>
            <van-radio-group v-model="message.sex">
              <van-radio name="0">男</van-radio>
              <van-radio name="1">女</van-radio>
            </van-radio-group>
          </div>

          <div class="cell" @click="datetimePicker">
            <div class="cell_label">出生年月日</div>
            <span v-if="message.birthday === ''" class="placeholder">请输入出生年月日</span>
            <span v-else>{{ message.birthday }}</span>
          </div>

          <div class="cell">
            <div class="cell_label">身高</div>
            <van-field v-model="message.height" placeholder="请输入身高" />
            <p>cm</p>
          </div>

          <div class="cell">
            <div class="cell_label">体重</div>
            <van-field v-model="message.weight" placeholder="请输入体重" />
            <p>kg</p>
          </div>

          <div class="cell">
            <div class="cell_label">腰围</div>
            <van-field v-model="message.waistline" placeholder="请输入腰围" />
            <p>cm</p>
          </div>

          <div class="cell">
            <div class="cell_label">城镇化</div>
            <van-radio-group v-model="message.tohr">
              <van-radio name="1">城镇</van-radio>
              <van-radio name="0">农村</van-radio>
            </van-radio-group>
          </div>

          <div class="cell" @click="areaPicker">
            <div class="cell_label">居住地</div>
            <span v-if="message.address === ''" class="placeholder">请输入居住地</span>
            <span v-else>{{ message.address }}</span>
          </div>
        </van-cell-group>
      </div>
      <Btn :btnData="{text: '下一步'}" @btnClick="changeStep({step1: false,step2: true}, 'step2')"></Btn>
    </div>

    <div class="step step2" v-show="step2">
      <div class="step_bg">
        <div class="titleBox">
          <div>
            <p>2/4：</p>
          </div>
          <div>
            <p>我们需要知道{{ child === 1 ? '孩子' : '您' }}的部分生活习惯</p>
            <p>以便更好的确认{{ child === 1 ? '孩子' : '您' }}目前的身体状况</p>
          </div>
        </div>
        <van-cell-group>
          <div class="cell">
            <div class="cell_label">吸烟</div>
            <van-radio-group v-model="message.smoke">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>

          <div class="cell" v-show="message.smoke === '1'">
            <div class="cell_label">日吸烟量</div>
            <van-field v-model="message.daynum" placeholder="请输入日吸烟量" />
            <p>根</p>
          </div>

          <div class="cell" v-show="message.smoke === '1'">
            <div class="cell_label">烟龄</div>
            <van-field v-model="message.smoke_year" placeholder="请输入烟龄" />
            <p>年</p>
          </div>

          <div class="cell">
            <div class="cell_label">饮酒</div>
            <van-radio-group v-model="message.drink">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>
        </van-cell-group>
      </div>
      <div class="btn_box">
        <Btn :btnData="{text: '上一步'}" @btnClick="changeStep({step1: true,step2: false}, 'step2')"></Btn>
        <Btn :btnData="{text: '下一步'}" @btnClick="changeStep({step2: false,step3: true}, 'step3')"></Btn>
      </div>
    </div>

    <div class="step step3" v-show="step3">
      <div class="step_bg">
        <div class="titleBox">
          <div>
            <p>3/4：</p>
          </div>
          <div>
            <p>我们需要知道{{ child === 1 ? '孩子' : '您' }}的部分体检数据</p>
            <p>以便更好的帮助{{ child === 1 ? '孩子' : '您' }}了解自己</p>
          </div>
        </div>
        <van-cell-group>
          <div class="cell">
            <div class="cell_label">空腹血糖</div>
            <van-field v-model="message.fpg" placeholder="请输入空腹血糖" />
            <p>mmol/L</p>
          </div>

          <div class="cell">
            <div class="cell_label">白细胞</div>
            <van-field v-model="message.wbc" placeholder="请输入白细胞" />
            <p>×10^9/L</p>
          </div>

          <div class="cell">
            <div class="cell_label">治疗血压</div>
            <van-field v-model="message.tobr_front" placeholder="舒张压" />
            <p>~</p>
            <van-field v-model="message.tobr_footer" placeholder="收缩压" />
            <p>mmHg</p>
          </div>

          <div class="cell">
            <div class="cell_label">非治疗血压</div>
            <van-field v-model="message.ntobr_front" placeholder="舒张压" />
            <p>~</p>
            <van-field v-model="message.ntobr_footer" placeholder="收缩压" />
            <p>mmHg</p>
          </div>

          <div class="cell">
            <div class="cell_label">总胆固醇</div>
            <van-field v-model="message.tc" placeholder="请输入总胆固醇" />
            <p>mmol/L</p>
          </div>

          <div class="cell">
            <div class="cell_label">甘油三酯</div>
            <van-field v-model="message.tg" placeholder="请输入甘油三酯" />
            <p>mmol/L</p>
          </div>

          <div class="cell">
            <div class="cell_label">高密度脂蛋白胆固醇(HDL-C)</div>
            <van-field v-model="message.hdlc" placeholder="请输入HDL-C" />
            <p>mmol/L</p>
          </div>

          <div class="cell">
            <div class="cell_label">低密度脂蛋白胆固醇(LDL-C)</div>
            <van-field v-model="message.ldlc" placeholder="请输入LDL-C" />
            <p>mmol/L</p>
          </div>

          <div class="cell">
            <div class="cell_label">谷草转氨酶(AST)</div>
            <van-field v-model="message.ast" placeholder="请输入AST" />
            <p>U/L</p>
          </div>

          <div class="cell">
            <div class="cell_label">谷丙转氨酶(ALT)</div>
            <van-field v-model="message.alt" placeholder="请输入ALT" />
            <p>U/L</p>
          </div>

          <div class="cell">
            <div class="cell_label">甲胎蛋白(AFP)</div>
            <van-field v-model="message.afp" placeholder="请输入AFP" />
            <p>ug/L(ng/ml)</p>
          </div>
        </van-cell-group>
      </div>
      <div class="btn_box">
        <Btn :btnData="{text: '上一步'}" @btnClick="changeStep({step3: false,step2: true}, 'step3')"></Btn>
        <Btn :btnData="{text: '下一步'}" @btnClick="changeStep({step3: false,step4: true}, 'step4')"></Btn>
      </div>
    </div>

    <div class="step step4" v-show="step4">
      <div class="step_bg">
        <div class="titleBox">
          <div>
            <p>4/4：</p>
          </div>
          <div>
            <p>我们需要知道{{ child === 1 ? '孩子' : '您' }}的部分现病史</p>
            <p>以便更好的帮助{{ child === 1 ? '孩子' : '您' }}完成评估</p>
          </div>
        </div>
        <van-cell-group>
          <div class="cell">
            <div class="cell_label">高血压</div>
            <van-radio-group v-model="message.hb">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>

          <div class="cell" v-show="message.hb === '1'">
            <div class="cell_label">是否服用降压药</div>
            <van-radio-group v-model="message.is_hbdrug">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>

          <div class="cell">
            <div class="cell_label">高血脂</div>
            <van-radio-group v-model="message.hpl">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>

          <div class="cell" v-show="message.hpl === '1'">
            <div class="cell_label">是否服用降脂药</div>
            <van-radio-group v-model="message.hpld">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>

          <div class="cell">
            <div class="cell_label">糖尿病</div>
            <van-radio-group v-model="message.dm">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>

          <div class="cell">
            <div class="cell_label">乙肝</div>
            <van-radio-group v-model="message.hbv">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>

          <div class="cell">
            <div class="cell_label">丙肝</div>
            <van-radio-group v-model="message.hcv">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>

          <div class="cell">
            <div class="cell_label">家人是否患有心血管病</div>
            <van-radio-group v-model="message.cd">
              <van-radio name="1">有</van-radio>
              <van-radio name="0">无</van-radio>
            </van-radio-group>
          </div>
        </van-cell-group>
      </div>
      <div class="btn_box">
        <Btn :btnData="{text: '上一步'}" @btnClick="changeStep({step4: false,step3: true}, 'step3')"></Btn>
        <Btn :btnData="{text: '完成'}" @btnClick="finishBtn"></Btn>
      </div>
    </div>

    <div class="step stepFinish" v-show="stepFinish">
      <div class="step_bg">
        <img src="../../assets/images/assessment/finish.png" alt="">

        <p>{{ child === 1 ? '孩子' : '您' }}已完成测评请耐心等待一段时间</p>
        <p>结果马上揭晓。。。</p>
        <p class="time"><span>{{ time }}</span> 秒后页面将跳转</p>
      </div>
    </div>

    <div class="step stepSkip" v-show="stepSkip">
      <div class="step_bg">
        <img src="../../assets/images/assessment/notFinish.png" alt="">

        <p>{{ child === 1 ? '孩子' : '您' }}未完成健康数据，暂时无法为{{ child === 1 ? '您的孩子' : '您' }}评估</p>

        <Btn :btnData="{text: '继续测评'}" @btnClick="continueBtn"></Btn>
      </div>
    </div>

    <div class="step stepHelp" v-show="stepHelp">
      <div class="step_bg">
        <img src="../../assets/images/assessment/notFinish.png" alt="">

        <p>{{ child === 1 ? '孩子' : '您' }}还未完成健康数据，暂时无法为{{ child === 1 ? '您的孩子' : '您' }}评估</p>
        <p>请联系{{ child === 1 ? '孩子' : '您' }}的医师协助完成</p>
      </div>
    </div>

    <van-popup v-model="datetime" position="bottom">
      <van-datetime-picker
        v-model="birthday"
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="datatimeCancel"
        @change="datatimeChange"
        @confirm="datatimeCancel"
        :formatter="formatter"
      />
    </van-popup>

    <van-popup v-model="area" position="bottom">
      <van-area
        :area-list="areaList"
        @cancel="areaCancel"
        @confirm="areaConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import Btn from '@/components/Btn'
import { Dialog } from 'vant'
import AreaList from '../../libs/area'
export default {
  name: 'assessment',
  components: {
    Btn
  },
  data () {
    return {
      birthday: new Date(1989, 12, 1),
      child: this.util.getLS(this.api.child), // 是否是儿童版报告
      message: {
        intotype: 0,
        sex: '', // 性别 0：男 1：女
        birthday: '', // 出生年月日
        height: '', // 身高
        weight: '', // 体重
        waistline: '', // 腰围
        tohr: '', // 户籍
        address: '', // 居住地
        smoke: '', // 吸烟 0：无 1:吸烟
        daynum: '', // 日吸烟量
        smoke_year: '', // 烟龄
        drink: '', // 饮酒 1：有 0：无
        fpg: '', // 空腹血糖
        wbc: '', // 白细胞量
        tobr_front: '', // 治疗血压小
        tobr_footer: '', // 治疗血压大
        ntobr_front: '', // 非治疗血压小
        ntobr_footer: '', // 非治疗血压大
        tc: '', // 总胆固醇量
        tg: '', // 甘油三酯
        hdlc: '', // 高密度脂蛋白胆固醇
        ldlc: '', // 低密度脂蛋白胆固醇
        ast: '', // 谷草转氨酶
        alt: '', // 谷丙转氨酶
        afp: '', // 甲胎蛋白
        hb: '', // 是否有高血压 1；有 0：无
        is_hbdrug: '', // 是否服用降压药 1；有 0：无
        hpl: '', // 是否是高血脂 1；有 0：无
        hpld: '', // 是否服用降脂药 1；有 0：无
        dm: '', // 是否有糖尿病 1；有 0：无
        hbv: '', // 是否患乙肝 1：有 0:无
        hcv: '', // 是否患丙肝 1：有 0：无
        cd: '' // 家人是否患有心血管病 1：有 0：无
      },
      step: 'step',
      step1: true,
      step2: false,
      step3: false,
      step4: false,
      stepFinish: false,
      stepSkip: false,
      stepHelp: false,
      datetime: false,
      minDate: new Date(1928, 12, 1),
      maxDate: new Date(),
      area: false,
      areaList: AreaList,
      time: 3 // 完成后倒计时跳转页面
    }
  },
  watch: {
    'step': function (val) {
      if (val === 'stepFinish') {
        this.autoChangePage()
      }
    }
  },
  methods: {
    getContinue () { // 获取中途退出保留的数据
      this.util.get(this.api.assessment_get_continue, '', (success) => {
        if (success.key === 0) {
          this.message = success.data
        }
      })
    },
    returnBtn () { // 返回按钮
      if (this.step !== 'stepFinish') {
        let data = new FormData()
        data.set('data', JSON.stringify(this.message))
        data.set('state', '0')
        Dialog.confirm({
          message: '您还未完成评估，内容将为您保存。\n' +
            '\n' +
            '是否离开当前页面？'
        }).then(() => {
          this.util.post(this.api.assessment_add_personinfo, data, (success) => {
            this.$router.push({ path: '/multiomics' })
          })
        }).catch(() => {
          // on cancel
        })
      } else {
        this.$router.push({ path: '/multiomics' })
      }
    },
    skipStep () { // 跳过
      this.stepSkip = true
      this.step = 'stepSkip'
    },
    changeStep (data, num) {
      Object.keys(data).forEach(item => {
        if (item in this) {
          this[item] = data[item]
        }
      })
      this.step = num
    },
    continueBtn () { // 继续
      this.stepSkip = false
      this.step = 'step'
    },
    finishBtn () { // 完成
      let data = new FormData()
      data.set('data', JSON.stringify(this.message))
      data.set('state', '1')
      this.util.post(this.api.assessment_add_personinfo, data, (success) => {
        this.changeStep({step4: false, stepFinish: true}, 'stepFinish')
      })
    },
    formatter (type, value) { // 日期选择---选项格式化
      if (type === 'year') {
        return `${value}年`
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      }
      return value
    },
    datetimePicker () { // 日期选择---显示
      this.datetime = true
    },
    datatimeCancel () { // 日期选择---取消 & 确定
      let month = this.birthday.getMonth() + 1
      let strDate = this.birthday.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      this.message.birthday = this.birthday.getFullYear() + '年' + month + '月' + strDate + '日'
      this.datetime = false
    },
    datatimeChange (e) { // 日期选择器---change
      let birthday = e.getValues()
      this.message.birthday = `${birthday[0]}${birthday[1]}${birthday[2]}`
    },
    areaPicker () { // 地区三级联动---显示
      this.area = true
    },
    areaCancel () { // 地区三级联动---取消
      this.area = false
    },
    areaConfirm (e) { // 地区三级联动---确定
      let arr = []
      e.forEach(item => {
        arr.push(item.name)
      })
      this.message.address = `${arr[0]},${arr[1]},${arr[2]}`
      this.area = false
    },
    autoChangePage () {
      const TIME_COUNT = 3
      if (!this.timer) {
        this.time = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.time > 0 && this.time <= TIME_COUNT) {
            this.time--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
            this.$router.push('/assessmentResult')
          }
        }, 1000)
      }
    }
  },
  mounted () {
    this.getContinue()
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .assessment {
    position: relative;
    padding: pxToRem(10px);

    .assessment_header {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      margin-bottom: pxToRem(20px);

      .assessment_header_left, .assessment_header_right {
        display: flex;
        align-items: center;
      }
    }

    .step {
      width: pxToRem(680px);
      margin: 0 auto;
      color: #040404;

      .step_bg {
        background-color: #fff;
        border-radius: pxToRem(30px);
        padding: pxToRem(40px) pxToRem(30px);
      }

      .titleBox {
        display: flex;
        font-size: pxToRem(30px);
        margin-bottom: pxToRem(50px);
      }

      .van-cell-group {
        padding: 10px 15px;

        .cell {
          display: flex;
          align-items: center;
          border-bottom: pxToRem(1px) solid #f5f6f8;
          padding: 10px 0;

          .placeholder {
            color: #97989a;
          }

          &:first-child {
            padding-top: 0;
          }

          &:last-child {
            border-bottom: none;
            padding-bottom: 0;
          }

          .cell_label {
            min-width: 90px;
          }

          .van-radio-group {
            display: flex;

            .van-radio:first-child {
              margin-right: 20px;
            }
          }

          .van-cell {
            width: 200px;
            padding: 0;
          }

          .van-cell:not(:last-child)::after {
            border-bottom: none;
          }
        }
      }

      .btn_box {
        display: flex;

        .btn {
          width: pxToRem(300px);
        }
      }
    }

    .step4 {

      .cell_label {
        min-width: 150px !important;
      }
    }

    .stepSkip {
      position: absolute;
      top: 50px;
      left: 0;
      right: 0;
      bottom: 0;
      height: 100%;
      background-color: #f9f9f9;
    }

    .stepSkip, .stepFinish, .stepHelp {

      .step_bg {
        padding: pxToRem(200px) pxToRem(60px);
        text-align: center;

        img {
          width: pxToRem(395px);
          margin-bottom: pxToRem(100px);
        }

        p {
          color: #595757;
          font-size: pxToRem(20px);
        }
      }

      p.time{
        margin-top: pxToRem(40px);

        span {
          color: #06a1c4;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/assessment/assessment.vue